import React from 'react';
import { useMapEvents } from 'react-leaflet';

const MapClickHandler = ({ onLocationSelect }) => {
  useMapEvents({
    click: (e) => {
      const { lat, lng } = e.latlng;
      onLocationSelect({
        id: crypto.randomUUID(), // CRITICAL: UUID for stable geo-identification
        latitude: lat,
        longitude: lng
      });
    },
  });
  return null;
};

export default MapClickHandler;
